import { Modal } from "react-bootstrap";
import {
  getSession,
  postLogin,
} from "../../../../../services/serviceVivetuseguro";
import * as CryptoJS from "crypto-js";
import { useEffect, useState } from "react";

const ModalActivarCuentaSuccess = ({
  infoApi,
  show,
  close,
  objUsuarioLogin,
  setLoading,
}) => {
  const [urlApi, setUrlApi] = useState("");

  const handleClose = () => close(false);

  const openEcosistema = () => {
    handleClose();
    setLoading(true);

    postLogin(objUsuarioLogin, urlApi)
      .then((rpta) => {
        if (rpta.codigo === 0) {
          localStorage.setItem(
            "token",
            CryptoJS.AES.encrypt(
              rpta.data.token,
              "8f6391895c404ab68eb7a8e42eb73587"
            )
          );

          getSession(rpta.data.token, urlApi).then((data) => {
            let res = { data }.data;
            localStorage.setItem(
              "user",
              CryptoJS.AES.encrypt(
                JSON.stringify(res),
                "8f6391895c404ab68eb7a8e42eb73587"
              )
            );

            let urlVivetuseguro = infoApi[0].urlFront + rpta.data.token + "&modulo=salud";
            window.open(urlVivetuseguro, "_blank");
            setLoading(false);
          });
        }
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (infoApi?.length < 1 || infoApi === undefined) return;
    infoApi.forEach((element) => {
      setUrlApi(element.urlApi);
    });
  }, [infoApi]);

  return (
    <Modal
      show={show}
      onHide={handleClose}
      className="modal__activar__success"
      centered
    >
      <Modal.Body>
        <div className="modal__success">
          <h2>¡Disfruta de tus beneficios!</h2>
          <p>
            Puedes usarlos cuantas veces quieras mientras tu seguro esté vigente
          </p>
          <div className="mt-3" style={{ textAlign: "center" }}>
            <button className="btn__azul" onClick={openEcosistema}>
              Ver Beneficios
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ModalActivarCuentaSuccess;
